export const calculateFlowStress = (smys, method = 'plus10000') => {
  const smysValue = parseFloat(smys) || 0;
  if (method === 'times1_1') {
    return (smysValue * 1.1).toFixed(2);
  } else {
    // Default to plus10000
    return (smysValue + 10000).toFixed(2);
  }
};

export const z = (diameter, length, wallThickness) => {
  const d = parseFloat(diameter) || 1; // avoid division by zero
  const l = parseFloat(length) || 0;
  const t = parseFloat(wallThickness) || 1;
  return Math.pow(l, 2) / (d * t);
};

export const calculateB31G_FailureStress = (depth, length, wallThickness, diameter, flowStress) => {
  const d = parseFloat(depth) || 0;
  const l = parseFloat(length) || 0;
  const t = parseFloat(wallThickness) || 1; // avoid division by zero
  const diam = parseFloat(diameter) || 0;
  const sFlow = parseFloat(flowStress) || 0;
  
  const two_thirds_d_over_t = 2*d / (3*t)
  var sFailure = 0;
  const z_local = z(diam, l, t) || 0;
  const m = Math.pow(1+0.8*z_local, 0.5);

  if (z_local <= 20) {
    sFailure = sFlow * (1-two_thirds_d_over_t) / (1-two_thirds_d_over_t/m);
  }else{
    sFailure = sFlow * (1-(d/t));
  }
  //console.log(`B31G Failure Stress Calculation: depth=${d}, length=${l}, wallThickness=${t}, flowStress=${sFlow}, z=${z_local}, m=${m}, sFailure=${sFailure}`);
  //console.log(`B31G: two_thirds_d_over_t=${two_thirds_d_over_t}`);

  return sFailure.toFixed(2);
};

export const calculateB31GModified_FailureStress = (depth, length, wallThickness, diameter, flowStress) => {
  const d = parseFloat(depth) || 0;
  const l = parseFloat(length) || 0;
  const t = parseFloat(wallThickness) || 1; // avoid division by zero
  const diam = parseFloat(diameter) || 0;
  const sFlow = parseFloat(flowStress) || 0;

  const eightyfive_d_over_t = 0.85 * d / (t);
  var sFailure = 0;
  //const z_local = z(diam, l, t) || 0;
  const m = b31GModified_FoliasFactor(length, wallThickness, diameter) || 0;
  
  sFailure = sFlow * (1-eightyfive_d_over_t) / (1-eightyfive_d_over_t/m);

  //console.log(`B31G Modified Failure Stress Calculation: depth=${d}, length=${l}, wallThickness=${t}, flowStress=${sFlow}, z=${z_local}, m=${m}, sFailure=${sFailure}`);
  //console.log(`B31G Mod: eightyfive_d_over_t=${eightyfive_d_over_t}`);

  return sFailure.toFixed(2);
}

export const b31GModified_FoliasFactor = (length, wallThickness, diameter) => {
  var m = 0;
  const z_local = z(diameter, length, wallThickness) || 0;

  if (z_local <= 50) {
    m = Math.pow(1.0 + 0.6275*z_local - 0.003375*Math.pow(z_local, 2), 0.5);
  }else{
    m = 0.032*z_local + 3.3;
  }
  return m;
}

export const calculateRSTRENG_FailureStress = (positionList, thicknessList, nominalThickness, diameter, flowStress) => {
  var sFailure = 0;
  var minAreaRatio = 1; // Start with the assumption that the area ratio is 1 (no loss of area)
  var locatlAreaRatio = 1;
  var lengthOfMinArea = 0;
  let localPositions;
  let localThicknesses;

  for (let i = 0; i < positionList.length; i++) {
    for (let j = i+1; j < thicknessList.length; j++) { 
      localPositions = positionList.slice(i, j+1);
      localThicknesses = thicknessList.slice(i, j+1);
      locatlAreaRatio = calculateArea(localPositions, localThicknesses);
      if (locatlAreaRatio < minAreaRatio) {
        minAreaRatio = locatlAreaRatio;
        lengthOfMinArea = localPositions[j] - localPositions[i];
      }
    }
  }

  const m = b31GModified_FoliasFactor(lengthOfMinArea, nominalThickness, diameter) || 0;  

  sFailure = flowStress * (1 - minAreaRatio) / (1 - minAreaRatio/m);

  //console.log(`RSTRENG Failure Stress Calculation: minAreaRatio=${minAreaRatio}, lengthOfMinArea=${lengthOfMinArea}, m=${m}, sFailure=${sFailure}`);  

  return sFailure.toFixed(2);
}

export function calculateArea(positionList, thicknessList) {
//Returns the area for the complete thickness profile.
//Requires at least two values in both positionList and thicknessList, and they must be the same length.
var area = 0;

  if (positionList.length < 2 || thicknessList.length < 2 || positionList.length !== thicknessList.length) {
    area = 0; // Not enough data or mismatched lengths
  }

  for (let i = 0; i < positionList.length - 1; i++) {
    const x1 = parseFloat(positionList[i]) || 0;
    const x2 = parseFloat(positionList[i + 1]) || 0;
    const t1 = parseFloat(thicknessList[i]) || 0;
    const t2 = parseFloat(thicknessList[i + 1]) || 0;

    // Calculate the area of the trapezoid formed by these two points
    const segmentArea = ((t1 + t2) / 2) * (x2 - x1);
    area += segmentArea;
  }

return area;
}
